export default {
  title: 'Renseignements personnels',
  warningTopText: 'Veuillez noter que si vous possédez des contrats auprès des institutions suivantes, vous devez communiquer directement avec elles pour mettre à jour vos renseignements personnels :',
  phoneLabel: 'Téléphone',
  emailLabel: 'Courriel',
  websiteLabel: 'Site internet',
  infoSeparator: ' : ',
  continueButton: 'Continuer',
};
